import { Card, Typography, Box, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import mainStyle from "../mainStyle.module.scss";
import { SolidButton } from "components/buttons/SolidButton";

const ControllerExpired = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      marginTop="100px"
    >
      <Card className={mainStyle["controller-invitation-card"]}>
        <Typography
          fontSize={theme.typography.customFontSize[5]}
          color={theme.palette.primary.main}
          fontWeight={theme.typography.customFontWeight[3]}
          letterSpacing="-1"
          fontFamily={theme.typography.fontFamily}
          marginTop="40px"
        >
          Invalid Invitation
        </Typography>
        <Divider sx={{ mb: 3, mt: 2 }} />

        <Typography
          sx={{
            mb: 1,
            color: theme.palette.primary.black,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[3],
            maxWidth: "828px",
            wordBreak: "break-word",
            whiteSpace: "normal",
            mx: "auto",
          }}
        >
          The invitation has expired.
        </Typography>

        <Box mt={4} display="flex" justifyContent="center" gap={2}>
          <SolidButton width="186px" height="42px" onClick={() => navigate("/")}>
            OK
          </SolidButton>
        </Box>
      </Card>
    </Box>
  );
};
export default ControllerExpired;
